export default "__VITE_PUBLIC_ASSET__70e7e63f__"